import { createAction } from 'redux-actions';

export const OpenSnackbar   = createAction('OPEN_SNACKBAR');
export const CloseSnackbar  = createAction('CLOSE_SNACKBAR');

export const OpenDialogNetworkError = createAction('OPEN_DIALOG_NETWORK_ERROR');
export const CloseDialogNetworkError  = createAction('CLOSE_DIALOG_NETWORK_ERROR');
